import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TripType = _resolveComponent("TripType")!
  const _component_TripCalendar = _resolveComponent("TripCalendar")!
  const _component_QuickformInput = _resolveComponent("QuickformInput")!

  return (_openBlock(), _createBlock(_component_QuickformInput, {
    value: _ctx.value,
    label: "Dates",
    id: "dates"
  }, {
    default: _withCtx(({close}) => [
      _createVNode(_component_TripType, { class: "quickform-triptype" }),
      _createVNode(_component_TripCalendar, {
        class: "quickform-calendar",
        onSelected: close,
        onDateChanged: _ctx.dateChanged
      }, null, 8, ["onSelected", "onDateChanged"])
    ]),
    _: 1
  }, 8, ["value"]))
}